import { selectAskPassword, selectAskVkAuth, selectInfo } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import { SurveyLang } from '../view/lang';

import { PwdAuth } from './pwd-auth';
import { VkAuth } from './vk-auth';

import css from './auth.css';

export const AuthView: VFC = () => {
    const askPassword = useStateSelector(selectAskPassword);
    const askVkAuth = useStateSelector(selectAskVkAuth);
    const { id, multiLang, defaultLang } = useStateSelector(selectInfo);

    return (
        <div className={css.auth}>
            {multiLang && <SurveyLang defaultLang={defaultLang} surveyId={id} />}
            {askPassword && <PwdAuth />}
            {askVkAuth && <VkAuth />}
        </div>
    );
};
